import React from "react";
import { DeleteOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { Button, ConfigProvider, Space, message, Modal } from "antd";
import { createStyles } from "antd-style";
import axios from "axios";
import localhost from "../../constants/localhost";

const useStyle = createStyles(({ prefixCls, css }) => ({
  linearGradientButton: css`
    &.${prefixCls}-btn-primary:not([disabled]):not(
        .${prefixCls}-btn-dangerous
      ) {
      > span {
        position: relative;
      }

      &::before {
        content: "";
        background: linear-gradient(
          135deg,
          rgb(247, 114, 5),
          rgb(223, 246, 16)
        );
        position: absolute;
        inset: -1px;
        opacity: 1;
        transition: all 0.3s;
        border-radius: inherit;
      }

      &:hover::before {
        opacity: 0;
      }
    }
  `,
}));

const App = ({ selectedRowKeys, batchRecycleCb }) => {
  const { styles } = useStyle();
  return (
    <>
      <ConfigProvider
        button={{
          className: styles.linearGradientButton,
        }}
      >
        <Space>
          <Button
            type="primary"
            icon={<DeleteOutlined />}
            onClick={() => {
              if (!selectedRowKeys.length) {
                message.warning("请先勾选素材，再进行批量回收操作！");
                return;
              }
              Modal.confirm({
                width: 450,
                title: `您已选择${selectedRowKeys.length}个素材，请确认是否进行批量回收操作！`,
                icon: <ExclamationCircleFilled />,
                content: "温馨提示：批量回收之后可到回收站中找回素材！",
                okText: "确定",
                cancelText: "取消",
                onOk() {
                  axios
                    .post(`${localhost}/manage/material/batchRecycle`, {
                      idList: selectedRowKeys,
                    })
                    .then((res) => {
                      message.success("批量回收成功！");
                      batchRecycleCb();
                    })
                    .catch((error) => {
                      message.error("网络异常，请重试！");
                      // setLoading(false);
                    });
                  // return new Promise((resolve, reject) => {
                  //   setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                  //   message.success("批量回收成功！");
                  // }).catch(() => console.log("Oops errors!"));
                },
                onCancel() {},
              });
            }}
          >
            批量回收
          </Button>
        </Space>
      </ConfigProvider>
    </>
  );
};
export default App;
